import { useAndReportExperimentTreatment } from '@ms/yammer-hooks/dist/experiments';
import type { FC, PropsWithChildren } from 'react';
import React, { Suspense } from 'react';

import LoadableResizableLeftNavInner from './LoadableResizableLeftNavInner';

export const ResizableLeftNavProvider: FC<PropsWithChildren> = ({ children }) => {
  const isEnabled = useAndReportExperimentTreatment('EngageIASimplificationNavRefresh');

  if (!isEnabled) {
    return <>{children}</>;
  }

  return (
    <Suspense fallback={<>{children}</>}>
      <LoadableResizableLeftNavInner>{children}</LoadableResizableLeftNavInner>
    </Suspense>
  );
};
